import React from 'react';
import { AnxiousEmoji } from 'radiance-ui/lib/icons';

import { Wrapper, Title, BodyText } from './style';

const InternalError = () => (
  <Wrapper>
    <AnxiousEmoji width={55} height={55} />
    <Title>Eeek! Something went wrong</Title>
    <BodyText>Please refresh the page and try again.</BodyText>
  </Wrapper>
);

export default InternalError;
